// import moment from "moment";
import PaymentService from "@/services/Payment";


const state = {
    tariffs: [],
    current_tariff: 0
};


const actions = {
    load: function (store) {
        if(state.tariffs.length) return;
        PaymentService.getTarifs().then((response) => {
            response.data.sort((a, b) => {
                return parseInt(a.price) - parseInt(b.price);
            });
            store.commit('SET_TARIFFS', response.data)
        })
    },
    set_current_tariff: function (state, price) {
        state.commit('SET_CURRENT_TARIFF', price)
    }

}
const mutations = {
    SET_TARIFFS: function (state, data = []) {
        state.tariffs = data
    },
    SET_CURRENT_TARIFF: function (state, price) {
        state.current_tariff = (+price).toString()
    }
}


const getters = {
    get: (state) => {
        return [...state.tariffs]
    }
}



export default {
    state,
    mutations,
    getters,
    actions
};
